var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12" },
    [
      _c(
        "button",
        {
          attrs: { id: "show-modal", type: "button" },
          on: { click: _vm.showModal },
        },
        [_vm._v("Show Modal")]
      ),
      _vm._v(" "),
      _c("vue-accessible-modal", {
        scopedSlots: _vm._u([
          {
            key: "backdrop",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
          {
            key: "header",
            fn: function () {
              return [_vm._v("Test")]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }